import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Sarv - Personalized Holistic Healthcare",
  description = "Get personalized natural health recommendations based on medicinal herbs tailored to your body and health goals.",
  keywords,
  canonicalPath = "",
  type = "website",
  noIndex = false,
  articleData = null,
  image,
}) => {
  const baseUrl = "https://joinsarv.com";
  const fullUrl = `${baseUrl}${canonicalPath}`;
  const ogImage = image || `${baseUrl}/img/og-image.jpg`;

  const defaultKeywords = [
    "personalized herbal medicine",
    "holistic health recommendations",
    "natural remedies",
    "medicinal herbs",
    "herbal medicine app",
    "herbal wellness",
    "Ayurveda",
    "naturopathy",
    "phytotherapy",
    "plant-based medicine",
    "natural remedies for anxiety",
    "natural remedies for sleep",
    "herbs for digestive health",
    "herbs for immune system",
    "personalized wellness app",
    "evidence-based herbal medicine",
    "Sarv",
  ].join(", ");

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={articleData ? "article" : type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Sarv" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Article-specific meta tags */}
      {articleData && (
        <>
          <meta property="article:published_time" content={articleData.publishedTime} />
          <meta property="article:modified_time" content={articleData.modifiedTime} />
          <meta property="article:author" content="Sarv Health Team" />
          <meta property="article:section" content={articleData.section || "Health & Wellness"} />
        </>
      )}
    </Helmet>
  );
};

export default SEO;
